<template>
    <div class="RossoCollege_home">
        <div class="vip1">
            <div class="v1_cont">
                <div class="p1">国际课程</div>
                <div class="p2">RoSSo College</div>
                <div class="p3">与知名国际学校强强联手，全面发展，全科育人+</div>
            </div>
        </div>
        <div class="rc2">
            <div class="title_box">
                <div class="title_cn">RoSSo College介绍</div>
                <div class="title_en">ROSSO COLLEGE INTRODUCTION</div>
            </div>
            <div class="rc2_cont">
                <p class="p1">RoSSo College艺术课程合作项目，由RoSSo国际艺术中心发起，与国内卓越的国际学校合作，在校开设艺术班和艺术公选课。<br><br> RoSSo
                    College基于IGCSE、A
                    Level课程体系，推广艺术课程进校，搭建艺术选修课与学术必修课相融合的课程体系。为学生提供更全面的学科教育，同时为在校学生提供艺术作品集辅导及艺术背景提升活动资源。目标是培养具备全球视野和综合竞争力的高素质人才。
                </p>

            </div>
        </div>
        <div class="rc3">
            <div class="title_box">
                <div class="title_cn">院校合作案例</div>
                <div class="title_en">COOPERATION CASES</div>
            </div>
            <div class="rc3_cont">
                <div class="swiper mySwiperRC1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="rc3_item">
                                <img src="../img/rossocollege/1.jpg" alt="">
                                <div class="rc3_p">
                                    富阳中学国际部
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/2.jpg" alt="">
                                <div class="rc3_p">
                                    金融街教育集团
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/3.jpg" alt="">
                                <div class="rc3_p">
                                    橘郡中学
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/4.jpg" alt="">
                                <div class="rc3_p">
                                    蓝润天使学校
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="rc3_item">
                                <img src="../img/rossocollege/5.jpg" alt="">
                                <div class="rc3_p">
                                    位育中学国际部
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/6.jpg" alt="">
                                <div>
                                    佛山惟德外国语学校
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/7.jpg" alt="">
                                <div class="rc3_p">
                                    兴高级中学国际部
                                </div>
                            </div>

                            <div class="rc3_item">
                                <img src="../img/rossocollege/8.jpg" alt="">
                                <div class="rc3_p">
                                    英澳美国际学校
                                </div>
                            </div>
                        </div>


                        <div class="swiper-slide">
                            <div class="rc3_item">
                                <img src="../img/rossocollege/9.jpg" alt="">
                                <div class="rc3_p">
                                    世界外国语中学
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/10.jpg" alt="">
                                <div class="rc3_p">
                                    平和双语学校
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/11.jpg" alt="">
                                <div class="rc3_p">
                                    上海中学国际部
                                </div>
                            </div>
                            <div class="rc3_item">
                                <img src="../img/rossocollege/12.jpg" alt="">
                                <div class="rc3_p">
                                    上海赫德璟旻艺术高中
                                </div>
                            </div>

                        </div>


                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </div>

        <div class="rc4">
            <div class="swiper mySwiperRC2">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="rc4_title">
                            <div class="title_left title_div"></div>
                            <div class="title_cont">RoSSo X 南京句容碧桂园学校服装/珠宝时尚艺术课堂</div>
                            <div class="title_right title_div"></div>
                        </div>
                        <img src="../img/rossocollege/Mask group-1.jpg" alt="">
                        <p>RoSSo为南京句容碧桂园学校艺术课堂的支持方以及提供社团指导老师，帮助学生们从眼睛的纪实角度出发，通过多材料尝试，明白常规插画（作为视觉设计素材）的集中记忆点，寻求视觉的突破点。然后，突破常规绘画手法，尝试多方法的手绘。
                        </p>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc4_title">
                            <div class="title_left title_div"></div>
                            <div class="title_cont">RoSSo X 上海位育中学国际部——艺术选修课</div>
                            <div class="title_right title_div"></div>
                        </div>
                        <img src="../img/rossocollege/Mask group-2.jpg" alt="">
                        <p>RoSSo作为上海位育中学国际部的艺术课程合作伙伴，参与设计与搭建艺术选修课程，特别是在高一年级开了一门产品设计课，共有22名学生参与。</p>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc4_title">
                            <div class="title_left title_div"></div>
                            <div class="title_cont">RoSSo X 上海平和双语国际学校——服装艺术社团指导课</div>
                            <div class="title_right title_div"></div>
                        </div>
                        <img src="../img/rossocollege/Mask group-3.jpg" alt="">
                        <p>RoSSo作为上海平和双语国际学校服装艺术社团的校外指导机构，每月不定期到校内参与指导，或者不定期校外，结合疫情也有线上指导等形式帮助平和的学生们完成自己的设计作品。</p>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <div class="rc4_btn">立即咨询</div>
            </a>
        </div>
        <div class="rc5">
            <div class="title_box">
                <div class="title_cn">课程体系</div>
                <div class="title_en">CURRICULUM INFORMATION</div>
            </div>
            <div class="rc5_cont">
                <div class="rc5_item">
                    <img src="../img/rossocollege/rc51.jpg" alt="">
                </div>
                <div class="rc5_item">
                    <img src="../img/rossocollege/rc52.jpg" alt="">
                </div>
            </div>
            <!-- <div class="swiper mySwiperRC3">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                       
                    </div>
                    <div class="swiper-slide">
                        <img src="../img/rossocollege/rc52.jpg" alt="">
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div> -->
            <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                <div class="rc4_btn">立即咨询</div>
            </a>
        </div>
        <div class="rc6">
            <div class="title_box">
                <div class="title_cn">艺术公选课<br>以及1V1课外拓展</div>
                <div class="title_en">ART CLASS INFORMATION</div>
            </div>
            <div class="rc6_cont">
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1540.jpg" alt="">
                    <div>视觉传达科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1541.jpg" alt="">
                    <div>商科管理科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1542.jpg" alt="">
                    <div>影视电影科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1543.jpg" alt="">
                    <div>建筑空间科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 365.jpg" alt="">
                    <div>工业教务科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1526.jpg" alt="">
                    <div>游戏动画科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1535.jpg" alt="">
                    <div>纯艺插画科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1534.jpg" alt="">
                    <div>FASHION科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1533.jpg" alt="">
                    <div>日本科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1528.jpg" alt="">
                    <div>音乐科系</div>
                </div>
                <div class="rc6_item">
                    <img src="../img/rossocollege/Rectangle 1527.jpg" alt="">
                    <div>国际课程</div>
                </div>
                <div class="rc6_item">

                </div>


            </div>
        </div>
        <div class="rc7">
            <div class="title_box">
                <div class="title_cn">合作办学亮点</div>
                <div class="title_en">ROSSO ADVANTAGE</div>
            </div>
            <div class="rc7_cont">
                <div class="rc7_item">
                    • 全面发展、全科育人。培养具备国际竞争力的综合人才
                </div>
                <div class="rc7_item">
                    • 基于IGCSE、A Level课程体系，助力艺术教育在校的推广
                </div>

                <div class="rc7_item">
                    • 丰富的艺术背景提升活动资源
                </div>
                <div class="rc7_item">
                    • 实行小班教学，因材施教
                </div>
                <div class="rc7_item">
                    • 优质师资，强强联合
                </div>
                <div class="rc7_item">
                    • 可在校完成艺术作品集，一步到位的艺术升学路径
                </div>
                <!-- <div class="rc7_item rc7_item7">
                    • 官方合作申请通道，不占UCAS名额
                    <img src="../img/rossocollege/Group 783.png" alt="" class="arrow animated rotateInUpLeft">
                    <div class="imgbox animated fadeInDown">
                        <div class="img1">

                            <img src="../img/rossocollege/image40.jpg" alt="">
                            <p>伯恩茅斯大学<br>官方合作授权书</p>
                        </div>
                        <div class="img2">

                            <img src="../img/rossocollege/image39.jpg" alt="">
                            <p>伦敦艺术大学预科<br>官方合作授权书</p>
                        </div>

                    </div>

                </div> -->

            </div>
        </div>
        <div class="rc8">
            <div class="title_box">
                <div class="title_cn">海外合作院校资源</div>
                <div class="title_en">OVERSEAS INSTITUTIONS RESOURCES</div>
            </div>

            <div class="swiper mySwiperRC4">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="rc8_cont">
                            <img class="rc8_item" src="../img/rossocollege/partner/1.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/3.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/4.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/5.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/6.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/7.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/8.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/21.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/9.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/10.jpg" alt="">

                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc8_cont">

                            <img class="rc8_item" src="../img/rossocollege/partner/11.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/12.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/13.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/14.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/15.jpg" alt="">

                            <img class="rc8_item" src="../img/rossocollege/partner/16.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/17.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/18.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/19.jpg" alt="">
                            <img class="rc8_item" src="../img/rossocollege/partner/20.jpg" alt="">

                            <!-- <img class="rc8_item" src="../img/rossocollege/partner/22.jpg" alt=""> -->
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>

        </div>

        <img class="rc10" src="../img/rossocollege/Group 788.jpg" alt="">
        <div class="v3">
            <div class="v3_cont">

                <div class="swiper mySwiperV3">
                    <div class="v3_title">
                        <p>国际师资团队 >></p>
                        <div class="v3_btn" @click="toggleV3(0)">#海外教授</div>
                        <div class="v3_btn" @click="toggleV3(1)">#海归导师</div>
                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in teacherData" :key=index>
                            <div class="v3_item" v-for="(item2, index2) in item" @click="teacherDetail(item2.id)" :key="index2">
                                <div class="img_box">
                                    <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar"
                                        alt="">
                                </div>
                                <span class="p1">{{ item2.school | schoolAll }}</span>
                                <h2>{{ item2.name | fliterName }}</h2>
                                <p class="p2">{{ item2.major }}</p>
                                <p class="p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div> -->
                </div>

            </div>

        </div>

        <div class="rc9">
            <div class="rc9_title">
                <p>优秀升学案例 >></p>
            </div>
            <div class="swiper mySwiperRC5">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image1.jpg" alt="">
                            <p class="p1">Wang 同学</p>
                            <div class="p2">
                                <p><span>A Level成绩：</span>摄影A，纺织A，中文A</p>
                                <p><span>BTEC：</span>Distinction</p>
                                <p><span>申请专业：</span>珠宝设计</p>
                                <p><span>录取结果：</span>伦敦艺术大学中央圣马丁艺术与设计学院、伦敦艺术大学伦敦时装学院、爱丁堡大学</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image2.jpg" alt="">
                            <P class="p1">Li 同学</P>
                            <div class="p2">
                                <p><span>A Level成绩：</span>纯艺A*，经济A，心理A</p>
                                <p><span>标化：</span>托福115</p>
                                <p><span>Rosso作品集：</span>服装设计</p>
                                <p><span>录取结果：</span>帕森斯设计学院（奖学金：48000美金）</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image3.jpg" alt="">
                            <P class="p1">Fan 同学</P>
                            <div class="p2">
                                <p><span>A Level成绩：</span>纯艺-A，中文A*, 数学A，经济A</p>
                                <p><span>标化：</span>雅思6.5</p>
                                <p><span>申请专业：</span>数字媒体</p>
                                <p><span>录取结果：</span>伦敦大学国王学院，伦敦艺术大学，多伦多大学、墨尔本大学、阿姆斯特丹大学</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image4.jpg" alt="">
                            <P class="p1">Zheng 同学</P>
                            <div class="p2">
                                <p><span>A Level成绩：</span>纺织A，摄影A，中文A</p>
                                <p><span>Rosso作品集：</span>服装设计</p>
                                <p><span>录取结果：</span>伦敦艺术大学</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image5.jpg" alt="">
                            <P class="p1">Wang 同学</P>
                            <div class="p2">
                                <p><span>A Level成绩：</span>纯艺预估A，中文预估A，数学A，物理A</p>
                                <p><span>BTEC：</span>Distinction</p>

                                <p><span>录取结果：</span>伦敦艺术大学</p>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-slide">
                        <div class="rc9_cont">
                            <img src="../img/rossocollege/image6.jpg" alt="">
                            <P class="p1">Zhang 同学</P>
                            <div class="p2">
                                <p><span>A Level成绩：</span>纯艺A，摄影预估A，中文A</p>
                                <p><span>Rosso作品集：</span>电影</p>
                                <p><span>录取结果：</span>伦敦大学金匠学院、爱丁堡大学、布里斯托大学</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>

        <div class="section_inp">
            <div class="s_inp_left">
                <img src="../img/Group 302.png" alt="" class="img_shou" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="1.2rem" :model="formLabelAlign"
                    style="justify-content: center;">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="输入姓名"></el-input>
                    </el-form-item>

                    <el-form-item label="意向专业：">
                        <el-input v-model="formLabelAlign.major" placeholder="意向专业"></el-input>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="输入电话号"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <!--  -->
    </div>
</template>
<script>
var _self
import Swiper from 'swiper/bundle'
// import  Swiper from 'swiper/vue';
import 'swiper/css';
import "swiper/css/effect-cards";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import axios from "axios"
import "@/assets/css/RossoCollege.css"
export default {
    data() {
        return {
            category: 2,
            teacherData: [],
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    filters: {
        fliterName(val) {
            // console.log(val, _self.category);
            return _self.category == 1 ? val : "Prof." + val
        },
        schoolAll(val) {
            return val.split(",")[1]
        },
        schoolSplit(val) {
            return val.split(",")[0]
        },
    },
    beforeCreate() {
        _self = this;
    },
    created() {
        this.getTeacherData()
    },
    watch: {
        // teacherData(val){
        //     console.log("监听器",val);
        //     this.mySwiperV3Init()
        // }
    },
    methods: {
        teacherDetail(val) {
            this.$router.push(`/teachers/${val}.html`)
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google.com")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing.com")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo.com")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu.com")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/
            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');
            } else {
                // console.log("不是空");
                if (patt.test(this.formLabelAlign.tel)) {
                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });
                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');
                }
            }
        },
        toggleV3(val) {
            // console.log(val);

            var v3_btn = document.getElementsByClassName("v3_btn")
            for (var i = 0; i < v3_btn.length; i++) {
                v3_btn[i].style.color = "#000"
                v3_btn[i].style.borderColor = "#000"
            }
            v3_btn[val].style.color = "#FB6333"
            v3_btn[val].style.borderColor = "#FB6333"
            if (val == 0) {
                this.category = 2


            } else {
                this.category = 1

            }
            this.getTeacherData()

        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getTeacherData() {
            axios.get(`https://public.rossoarts.com/api/v1/getFirstTeacher?category=${this.category}&limit=12`).then((data) => {
                // console.log(data.data);
                this.teacherData = this.arrGroup(data.data, 4)
                // console.log(this.teacherData);
                this.$nextTick(() => {
                    this.mySwiperV3Init()
                })
            })
        },
        mySwiperRC1Init() {
            var swiper = new Swiper(".mySwiperRC1", {
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        mySwiperRC2Init() {
            var swiper = new Swiper(".mySwiperRC2", {
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        mySwiperRC3Init() {
            var swiper = new Swiper(".mySwiperRC3", {
                // loop: true,
                observer:true,
                // autoHeight: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        mySwiperRC4Init() {
            var swiper = new Swiper(".mySwiperRC4", {
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        mySwiperRC5Init() {
            var swiper = new Swiper(".mySwiperRC5", {
                loop: true,
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
        mySwiperV3Init() {
            new Swiper('.mySwiperV3', {
                loop: true,

                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    observe: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },
    },
    mounted() {
        this.mySwiperV3Init()
        this.mySwiperRC1Init()
        this.mySwiperRC2Init()
        this.mySwiperRC3Init()
        this.mySwiperRC4Init()
        this.mySwiperRC5Init()
    }
}
</script>